import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'okr-tracker.field-1-name': {
    id: 'okr-tracker.field-1-name',
    defaultMessage: 'Key result',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Key result',
  },
  'okr-tracker.field-2-name': {
    id: 'okr-tracker.field-2-name',
    defaultMessage: 'Progress',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Progress',
  },
  'okr-tracker.field-3-name': {
    id: 'okr-tracker.field-3-name',
    defaultMessage: 'Owner',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Owner',
  },
  'okr-tracker.field-4-name': {
    id: 'okr-tracker.field-4-name',
    defaultMessage: 'Status',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Status',
  },
  'okr-tracker.field-4-select-option-1': {
    id: 'okr-tracker.field-4-select-option-1',
    defaultMessage: 'At Risk',
    description:
      'The option value for option #1 in field #4 for this database template. In this case: At Risk',
  },
  'okr-tracker.field-4-select-option-2': {
    id: 'okr-tracker.field-4-select-option-2',
    defaultMessage: 'Paused',
    description:
      'The option value for option #2 in field #4 for this database template. In this case: Paused',
  },
  'okr-tracker.field-4-select-option-3': {
    id: 'okr-tracker.field-4-select-option-3',
    defaultMessage: 'On Track',
    description:
      'The option value for option #3 in field #4 for this database template. In this case: On Track',
  },
  'okr-tracker.field-4-select-option-4': {
    id: 'okr-tracker.field-4-select-option-4',
    defaultMessage: 'Completed',
    description:
      'The option value for option #4 in field #4 for this database template. In this case: Completed',
  },
  'okr-tracker.field-5-name': {
    id: 'okr-tracker.field-5-name',
    defaultMessage: 'Quarter',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Quarter',
  },
  'okr-tracker.field-5-select-option-1': {
    id: 'okr-tracker.field-5-select-option-1',
    defaultMessage: 'Q2',
    description:
      'The option value for option #1 in field #5 for this database template. In this case: Q2',
  },
  'okr-tracker.field-5-select-option-2': {
    id: 'okr-tracker.field-5-select-option-2',
    defaultMessage: 'Q1',
    description:
      'The option value for option #2 in field #5 for this database template. In this case: Q1',
  },
  'okr-tracker.field-5-select-option-3': {
    id: 'okr-tracker.field-5-select-option-3',
    defaultMessage: 'Q3',
    description:
      'The option value for option #3 in field #5 for this database template. In this case: Q3',
  },
  'okr-tracker.field-6-name': {
    id: 'okr-tracker.field-6-name',
    defaultMessage: 'Goal',
    description:
      'The field name (and the default value/watermark) in field #6 for this database template. In this case: Goal',
  },
  'okr-tracker.view-1-name': {
    id: 'okr-tracker.view-1-name',
    defaultMessage: 'All OKRs',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All OKRs',
  },
  'okr-tracker.entry-1-cell-2': {
    id: 'okr-tracker.entry-1-cell-2',
    defaultMessage: 'Increase system uptime from 99.5% to 99.9% next quarter',
    description:
      'The text value of cell #2 in row (entry) #1 in this database template. In this case:  Increase system uptime from 99.5% to 99.9% next quarter',
  },
  'okr-tracker.entry-2-cell-2': {
    id: 'okr-tracker.entry-2-cell-2',
    defaultMessage: 'Increase monthly active users by 10%',
    description:
      'The text value of cell #2 in row (entry) #2 in this database template. In this case:  Increase monthly active users by 10%',
  },
  'okr-tracker.entry-3-cell-2': {
    id: 'okr-tracker.entry-3-cell-2',
    defaultMessage: 'Achieve 85% participation in quarterly code reviews',
    description:
      'The text value of cell #2 in row (entry) #3 in this database template. In this case:  Achieve 85% participation in quarterly code reviews',
  },
  'okr-tracker.entry-4-cell-2': {
    id: 'okr-tracker.entry-4-cell-2',
    defaultMessage: 'Implement two-factor authentication for all users',
    description:
      'The text value of cell #2 in row (entry) #4 in this database template. In this case:  Implement two-factor authentication for all users',
  },
});
